import isUrl from "is-url"
import { getEventTransfer } from "@convertkit/slate-react"

const handledTransferType = type => type == "text" || type == "html"

export default () => ({
  onPaste(event, editor, next) {
    const transfer = getEventTransfer(event)
    const supportedVideoLinkSnippet = /\S*youtube\.com\/\S*\/*watch\S*|youtu\.be/
    if (!handledTransferType(transfer.type)) return next()
    if (!isUrl(transfer.text)) return next()
    if (!transfer.text.match(supportedVideoLinkSnippet)) return next()
    return editor.insertVideo({ href: transfer.text })
  }
})
